import { ActionLogRepositoryInterface, SearchActionLogsOptions, SearchActionLogsResponse } from "./interfaces";

import { AxiosInstance } from "axios";

export default class ActionLogRepository
  implements ActionLogRepositoryInterface {
  public static BaseURL = "/tracing";

  constructor(private readonly axios: AxiosInstance) {
  }

  public search(
    options: SearchActionLogsOptions,
  ): Promise<SearchActionLogsResponse> {
    return this.axios
      .get(ActionLogRepository.BaseURL, {
        params: {
          ...options,
          ...(options?.tags ? { tags: btoa(JSON.stringify(options.tags)) } : {}),
        },
      })
      .then((response) => {
        const data = response.data;
        if (!data.data) {
          data.data = [];
        }

        return data;
      });
  }
}
